"use client"
/* */
import { createContext, useContext } from 'react';

const slotContext = createContext({});
const useSlotContext = () => useContext(slotContext);

export { slotContext, useSlotContext };
//# sourceMappingURL=slotContext.mjs.map
